import React from 'react';
import Header from '../components/Header';
import DownloadCards from '../components/DownloadCards';
import Problem from '../components/Problem';
import Features from '../components/Features';
import WhoFor from '../components/WhoFor';
import Situations from '../components/Situations';
import Screenshots from '../components/Screenshots';
import Faq from '../components/Faq';
import Footer from '../components/Footer';
import useHead from '../useHead';

export default function Home() {
  useHead({
    title: 'ConvoLines — Speak English for Real Life',
    description:
      'Practice speaking English for real life with 900+ real conversations, useful spoken lines, audio, role play, and quizzes for the everyday situations you actually face.',
    path: '/',
  });

  return (
    <div className="page">
      <Header />

      <section className="hero">
        <div className="hero__grid">
          <div className="hero__text">
            <h1>Stop freezing when you need to speak English.</h1>
            <p className="hero__subtitle">
              Practice real conversations, useful spoken lines, audio, role play, and
              quizzes for the everyday situations you actually face.
            </p>
            <DownloadCards />
            <div className="stat-row">
              <span>900+ conversations</span>
              <span>300+ quizzes</span>
              <span>25+ categories</span>
              <span>iOS &amp; Android</span>
            </div>
          </div>
          <div className="hero__image">
            <img
              src="/screenshots/conversation.jpg"
              alt="A ConvoLines conversation about rescheduling a haircut appointment, shown line by line"
              className="phone-mockup"
              width={580}
              height={1260}
              fetchPriority="high"
            />
          </div>
        </div>
      </section>

      <Problem />
      <Features />
      <WhoFor />
      <Situations />
      <Screenshots />
      <Faq />

      <section className="section section--cta">
        <h2 className="section__title">Everything is free. Start practicing today.</h2>
        <p>
          All categories, 900+ conversations, useful spoken lines, audio practice, role
          play, saved review, and 300+ quizzes — free for everyone. Want it ad-free?
          Premium removes the ads.
        </p>
        <a className="btn btn--primary" href="#download">
          Start practicing
        </a>
      </section>

      <Footer />
    </div>
  );
}
